// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Custom styles for MDAutocomplete
import MDAutocompleteRoot from "components/MDAutocomplete/MDAutocompleteRoot";
import MDInput from "components/MDInput";
import styled from "@emotion/styled";
import MDTypography from "components/MDTypography";
import { Popper, TextField, Autocomplete } from "@mui/material";

const GroupHeader = styled("div")(({ theme }) => ({
  position: "sticky",
  top: "-8px",
  padding: "2px 8px",
  color: "white",
  backgroundColor: "#90B494",
}));

const GroupItems = styled("ul")({
  padding: 0,
});
const MDAutocomplete = ({
  label,
  name,
  options = [],
  groupBy = (option) => option.firstLetter,
  getOptionLabel = (option) => option.title,
  formik,
  placeholder = "Select Option",
  required,
  value,
  onChange,
  error,
  helperText,
}) => {
  const selectedValue = formik
    ? options.find(
        (option) => option.value === formik.values[name] || option.title === formik.values[name]
      )
    : options.find((option) => option.value === value);

  const handleChange = (event, newValue) => {
    if (formik) {
      formik.setFieldValue(name, newValue ? newValue.value || newValue.title : "");
    } else if (onChange) {
      onChange(newValue?.value ?? "");
    }
  };
  return (
    <>
      <MDTypography style={{ fontSize: "16px", textTransform: "capitalize" }} color="dark">
        {label} <span style={{ color: "red" }}>{required ? "*" : ""}</span>
      </MDTypography>
      <Autocomplete
        options={options}
        groupBy={groupBy}
        getOptionLabel={getOptionLabel}
        fullWidth
        renderInput={(params) => (
          <TextField
            {...params}
            error={error || (formik ? Boolean(formik.touched[name] && formik.errors[name]) : false)}
            helperText={helperText || (formik && formik.touched[name] ? formik.errors[name] : "")}
            placeholder={placeholder}
            style={{ fontSize: "16px" }}
          />
        )}
        value={selectedValue || null}
        onChange={handleChange}
      />
    </>
  );
};

MDAutocomplete.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.array,
  formik: PropTypes.object,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  groupBy: PropTypes.func,
  getOptionLabel: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.any,
  error: PropTypes.bool,
  helperText: PropTypes.string,
};

export default MDAutocomplete;
